import UniformAccordion from "./components/accordion";
import UniformAgileArticleBodyContent from "./components/agile-article-body-content";
import UniformAgileHubSidebarNav from "./components/agile-hub-sidebar-nav";
import UniformAgileTutorialBodyContent from "./components/agile-tutorial-body-content";
import UniformArticleIntroductionContent from "./components/article-introduction-content";
import UniformBackgroundVideoContainer from "./components/background-video-container";
import UniformBannerAlert from "./components/banner-alert";
import UniformBodyContent from "./components/body-content";
import { default as UniformBodyContentV1 } from "./components/body-content-v1";
import UniformButton from "./components/button";
import UniformCallToAction from "./components/call-to-action";
import UniformCard from "./components/card";
import UniformCollectionPricingHero from "./components/collection-pricing-hero";
import {
    UniformColumnLayout,
    UniformSubColumnLayout
} from "./components/column-layout";
import UniformConfluenceAnimatedHero from "./components/confluence-animated-hero";
import UniformConnector from "./components/connector";
import UniformContainer from "./components/container";
import UniformContentBlock from "./components/content-block";
import UniformCustomerStat from "./components/customer-stat";
import UniformCustomerStoriesDetailsHero from "./components/customer-stories-details-hero";
import UniformCustomerTestimonials from "./components/customer-testimonials";
import UniformExpand from "./components/expand/src/expand";
import UniformFeaturesHighlight from "./components/features-highlight";
import UniformGlobalFooter from "./components/global-footer";
import UniformGlobalNav from "./components/global-nav";
import UniformHeading from "./components/heading";
import UniformHeroCarousel from "./components/hero-carousel";
import UniformHeroCarouselV0 from "./components/hero-carousel-v0";
import UniformHeroSection from "./components/hero-section";
import UniformHorizontalDivider from "./components/horizontal-divider";
import UniformImage from "./components/image";
import UniformImageV2 from "./components/image-v2";
import UniformIntegration from "./components/integration";
import UniformInvisibleContent from "./components/invisible-content";
import UniformJiraTemplatesTabContentSubgridLayout from "./components/jira-templates-tab-content-subgrid-layout";
import UniformLink from "./components/link";
import UniformList from "./components/list";
import UniformListV2 from "./components/listv2";
import UniformLogos from "./components/logos";
import UniformLozenge from "./components/lozenge";
import UniformMobileApp from "./components/mobile-app";
import UniformModal from "./components/modal";
import UniformPage from "./components/page";
import UniformPagination from "./components/pagination";
import UniformPanel from "./components/panel";
import UniformPersonalizationContainer from "./components/personalization-container";
import UniformPricingCalculator from "./components/pricing-calculator";
import UniformPricingTable from "./components/pricing-table";
import UniformProductCard from "./components/product-card";
import UniformPullQuote from "./components/pull-quote";
import UniformRovoHero from "./components/rovo-hero";
import UniformScrollableHeroCards from "./components/scrollable-cards";
import UniformSideNav from "./components/side-nav/src/side-nav";
import UniformSideNavCollection from "./components/side-nav-collection";
import UniformSideNavLink from "./components/side-nav-link";
import UniformSignUpForm from "./components/sign-up-form";
import UniformSingleTab from "./components/single-tab";
import UniformSplitColorBackgroundContainer from "./components/split-color-background-container";
import UniformStatsSection from "./components/stats-section";
import UniformStatsigExperimentContainer from "./components/statsig-experiment-container";
import UniformStatsigFeatureGateContainer from "./components/statsig-feature-gate-container";
import UniformTabs12Col from "./components/tabs-12-col";
import UniformTabs8Col from "./components/tabs-8-col";
import UniformTemplateCta from "./components/template-cta";
import UniformTemplateModalButton from "./components/template-modal-button";
import UniformTemplatePreview from "./components/template-preview";
import UniformText from "./components/text";
import UniformTextWithIcon from "./components/text-with-icon";
import UniformTopicIntroductionContent from "./components/topic-introduction-content";
import UniformTutorialIntroductionContent from "./components/tutorial-introduction-content";
import UniformVariant from "./components/variant";
import UniformVariantContainer from "./components/variant-container";
import UniformVideo from "./components/video";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const UNIFORM_DEFINITIONS: Record<string, any> = {
    accordion: UniformAccordion,
    agileArticleBodyContent: UniformAgileArticleBodyContent,
    agileHubSidebarNav: UniformAgileHubSidebarNav,
    agileTutorialBodyContent: UniformAgileTutorialBodyContent,
    articleIntroductionContent: UniformArticleIntroductionContent,
    backgroundVideoContainer: UniformBackgroundVideoContainer,
    bannerAlert: UniformBannerAlert,
    blockContainer: UniformContainer,
    bodyContent: UniformBodyContent,
    button: UniformButton,
    card: UniformCard,
    collectionPricingHero: UniformCollectionPricingHero,
    columnLayout: UniformColumnLayout,
    confluenceAnimatedHero: UniformConfluenceAnimatedHero,
    connector: UniformConnector,
    contentBlock: UniformContentBlock,
    ctaWithPolygonBackground: UniformCallToAction,
    customerBodyContent: UniformBodyContentV1,
    customerStat: UniformCustomerStat,
    customerStoriesDetailsHero: UniformCustomerStoriesDetailsHero,
    customerTestimonials: UniformCustomerTestimonials,
    expand: UniformExpand,
    featuresHighlight: UniformFeaturesHighlight,
    globalFooter: UniformGlobalFooter,
    globalNav: UniformGlobalNav,
    heading: UniformHeading,
    heroCarousel: UniformHeroCarouselV0,
    heroCarouselSection: UniformHeroCarousel,
    heroSection: UniformHeroSection,
    horizontalDivider: UniformHorizontalDivider,
    image: UniformImage,
    imageV2: UniformImageV2,
    integration: UniformIntegration,
    invisibleContent: UniformInvisibleContent,
    scrollableHeroCards: UniformScrollableHeroCards,
    jiraTemplatesTabContentSubgridLayout:
        UniformJiraTemplatesTabContentSubgridLayout,
    link: UniformLink,
    list: UniformList,
    listv2: UniformListV2,
    logos: UniformLogos,
    lozenge: UniformLozenge,
    mobileApp: UniformMobileApp,
    modal: UniformModal,
    page: UniformPage,
    pagination: UniformPagination,
    panel: UniformPanel,
    personalizationContainer: UniformPersonalizationContainer,
    pricingCalculator: UniformPricingCalculator,
    pricingTable: UniformPricingTable,
    productCard: UniformProductCard,
    rovoHero: UniformRovoHero,
    sideNav: UniformSideNav,
    sideNavCollection: UniformSideNavCollection,
    sideNavLink: UniformSideNavLink,
    signUpForm: UniformSignUpForm,
    templateCta: UniformTemplateCta,
    pullQuote: UniformPullQuote,
    singleTab: UniformSingleTab,
    splitBackgroundContainer: UniformSplitColorBackgroundContainer,
    statsSection: UniformStatsSection,
    statsigExperimentContainer: UniformStatsigExperimentContainer,
    statsigFeatureGateContainer: UniformStatsigFeatureGateContainer,
    subColumnLayout: UniformSubColumnLayout,
    tabs12Col: UniformTabs12Col,
    tabs8Col: UniformTabs8Col,
    templateModalButton: UniformTemplateModalButton,
    templatePreview: UniformTemplatePreview,
    text: UniformText,
    textWithIcon: UniformTextWithIcon,
    topicIntroductionContent: UniformTopicIntroductionContent,
    tutorialIntroductionContent: UniformTutorialIntroductionContent,
    variant: UniformVariant,
    variantContainer: UniformVariantContainer,
    video: UniformVideo
};

export default UNIFORM_DEFINITIONS;
